import React, { Component, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { constants } from '../constants.js'
import { Svg } from './Svg.js'
import i18next from '../i18n.js'
import { base64toBlob } from './helpers/HelperFunctions.js'
import PdfViewer from './PdfViewer.js'
import { InputMask } from '@react-input/mask'
//const mime = require("mime-types");
export const showModalDialog = showModal;
export const hideModalDialog = hideModal;
class ModalDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCompanyName: ''
		};
		this.closeDialog = this.closeDialog.bind(this);
	}
	static getDerivedStateFromProps(props, state) {
		return state;
	}
	closeDialog() {
		const { dialogId, canClose, closeCalback } = this.props;
		if (canClose) {
			hideModal(dialogId);
			if (closeCalback)
				closeCalback();
		}
	}
	render() {
		const { dialogId, children, header, icone, additionalClasses, buttons, canClose, headerIconButtons } = this.props;
		const { currentCompanyName } = this.state;
		const closeDialogFunction = this.closeDialog;
		let dialogFormId = "form_" + dialogId;
		let index = 0;
		return (
			<div className={"modal fade show " + (additionalClasses ? additionalClasses : "") + (canClose ? " can-close" : "") + (header ? " with-title" : "")} id={dialogFormId} onMouseDown={(e) => {
				e = e || window.event;
				var target = e.target || e.srcElement;
				var mouseUpEvent = function(e) {
					e = e || window.event;
					var upTarget = e.target || e.srcElement;
					if (upTarget.id === dialogFormId) {
						closeDialogFunction();
						target.removeEventListener("mouseup", mouseUpEvent);
					}
					else target.removeEventListener("mouseup", mouseUpEvent);
				}
				if (target.id === dialogFormId) target.addEventListener("mouseup", mouseUpEvent);
			}}>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className={"modal-header" + (icone || header ? " with-icon" : "") + (headerIconButtons && headerIconButtons.length > 0 ? " with-header-btns" : "")}>
							{icone && <img className="modal-icone" src={icone} alt="" />}
							{
								!header &&
								<div className="form-header-subtitle-right form-subtitle">{currentCompanyName}</div>
							}
							{header && <div className="modal-header-title">{header}</div>}
							{headerIconButtons &&
								<div className="header-btns">
									{headerIconButtons.map(btn =>
										<div className="header-icon-btn" onClick={btn.onClickCallback}>
											<Svg src={btn.src} />
										</div>
									)}
								</div>
							}
							{canClose && <button type="button" className="close m-0 btn" onClick={closeDialogFunction}>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black" />
								</svg>
							</button>}
						</div>
						<div className="modal-body">
							{children}
						</div>
						{buttons && buttons.length > 0 &&
							<div className="modal-footer">
								<div className="btns">
									{buttons.map(btn =>
										<button type="button" className={"btn " + btn.class} key={"btn_" + index++} onClick={btn.clickHandler && btn.clickHandler}>{btn.title}</button>
									)}
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		);
	}
}
function showModal(dialogId, header, icone, children, additionalClasses, canClose = true, buttons = [], closeCalback = null, headerIconButtons = []) {
	if (constants.placeholderDialogId !== dialogId)
		hideModal(constants.placeholderDialogId);
	var dialog = document.getElementById(dialogId);
	if (dialog) {
		const root = createRoot(dialog);
		root.render(
			<ModalDialog header={header} icone={icone} dialogId={dialogId} additionalClasses={additionalClasses} canClose={canClose} buttons={buttons} closeCalback={closeCalback} headerIconButtons={headerIconButtons} >
				{children}
			</ModalDialog>);
		if (document.body.style.position !== "fixed") {
			document.body.style.top = "-" + getBodyScrollTop() + "px";
			document.body.style.overflowY = "scroll";
			document.body.style.width = "100%";
			document.body.style.position = "fixed";
		}
	}
}
function hideModal(dialogId) {
	var dialog = document.getElementById(dialogId);
	const root = createRoot(dialog);
	root.render("");
	var scrollValue = document.body.style.top;
	if (scrollValue.startsWith('-'))
		scrollValue = scrollValue.substring(1);
	if (scrollValue.endsWith('px'))
		scrollValue = scrollValue.substring(0, scrollValue.length - 2);
	let style = document.body.style;
	style.overflowY = style.width = style.position = style.top = "";
	if (scrollValue)
		window.scrollTo(0, parseInt(scrollValue));
}
function getBodyScrollTop() {
	return window.scrollY ? window.scrollY : (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop);
}
export function yesNoDialog(title, message, yesClickHandler, noClickHandler, onCloseHandler) {
	const closeDialog = () => {
		hideModalDialog("loadingDialog");
		if (onCloseHandler) onCloseHandler();
	}
	const rejectDialog = () => {
		hideModalDialog("loadingDialog");
		if (noClickHandler) noClickHandler();
	}
	const confirmDialog = () => {
		hideModalDialog("loadingDialog");
		if (yesClickHandler) yesClickHandler();
	}
	showModalDialog("loadingDialog", title, "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: confirmDialog, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: rejectDialog, class: "btn-primary" }], closeDialog)
}
// fields: [{ name, placeholder, mask }] — усі поля обов'язкові, незаповнені підсвічуються
// після підтвердження. Поле з mask вводиться за маскою, тому заповненим вважається лише
// тоді, коли введені всі її символи — інакше збереглась би частина номера
const DeliveryPlaceForm = (props) => {
	const [values, setValues] = useState({});
	const [submitted, setSubmitted] = useState(false);

	const isEmpty = (field) => {
		const value = values[field.name]?.trim() ?? '';
		return field.mask ? value.length < field.mask.length : !value;
	}

	const confirmHandle = () => {
		if (props.fields.some(isEmpty)) {
			setSubmitted(true);
			return;
		}
		props.onConfirm(values);
	}

	const changeHandle = (field, value) => setValues({ ...values, [field.name]: value });

	// Незмінна частина маски — все до першого символу, що вводиться: для телефону це «+38(0»
	const maskPrefix = (field) => field.mask.split('_')[0];

	// Префікс підставляється, щойно користувач став у поле, і лишається там: спроба стерти
	// його повертає поле до префікса, тож видалити можна лише введені цифри
	const maskFocusHandle = (field) => {
		if ((values[field.name] ?? '').length < maskPrefix(field).length) {
			changeHandle(field, maskPrefix(field));
		}
	}

	const maskChangeHandle = (field, value) => {
		const prefix = maskPrefix(field);
		changeHandle(field, value.length < prefix.length ? prefix : value);
	}

	return (<div className="delivery-place-form">
		<div className="delivery-place-fields">
			{props.fields.map(field =>
				<div className={"delivery-place-row" + (submitted && isEmpty(field) ? " invalid" : "")} key={field.name}>
					{field.mask
						? <InputMask className="form-control" mask={field.mask} replacement={{ _: /\d/ }} name={field.name}
							placeholder={field.placeholder} value={values[field.name] ?? ''}
							onFocus={() => maskFocusHandle(field)}
							onChange={(e) => maskChangeHandle(field, e.target.value)} />
						: <input className="form-control" name={field.name} placeholder={field.placeholder} value={values[field.name] ?? ''}
							onChange={(e) => changeHandle(field, e.target.value)} />}
				</div>
			)}
		</div>
		<button type="button" className="btn delivery-place-confirm" onClick={confirmHandle}>{i18next.t("confirm")}</button>
	</div>);
}
export function deliveryPlaceDialog(fields, confirmClickHandler, closeClickHandler) {
	const confirmDialog = (values) => {
		hideModalDialog('modalDialog');
		if (confirmClickHandler) confirmClickHandler(values);
	}
	showModalDialog('modalDialog', "", "", <DeliveryPlaceForm fields={fields} onConfirm={confirmDialog} />,
		"delivery-place-popup", true, [], closeClickHandler)
}
// Нижнє вікно з полем для введення посилання, яке додається в поле attachments
const LinkForm = (props) => {
	const [link, setLink] = useState('');
	const [submitted, setSubmitted] = useState(false);

	const isEmpty = !link.trim();

	const confirmHandle = () => {
		if (isEmpty) {
			setSubmitted(true);
			return;
		}
		props.onConfirm(link.trim());
	}

	return (<div className="add-link-form">
		<div className="add-link-fields">
			<div className={"add-link-row" + (submitted && isEmpty ? " invalid" : "")}>
				<input className="form-control" name="link" placeholder={i18next.t("document.attachmentLinkPlaceholder")} value={link}
					onChange={(e) => setLink(e.target.value)} />
			</div>
		</div>
		<button type="button" className="btn add-link-confirm" onClick={confirmHandle}>{i18next.t("confirm")}</button>
	</div>);
}
export function addLinkDialog(confirmClickHandler) {
	const confirmDialog = (link) => {
		hideModalDialog('modalDialog');
		if (confirmClickHandler) confirmClickHandler(link);
	}
	showModalDialog('modalDialog', "", "", <LinkForm onConfirm={confirmDialog} />, "add-link-popup", true)
}
export function confirmChangeDialog(title, message, confirmBtnTitle, yesClickHandler, noClickHandler) {
	const rejectDialog = () => {
		hideModalDialog('modalDialog');
		if (noClickHandler) noClickHandler();
	}
	const confirmDialog = () => {
		hideModalDialog('modalDialog');
		if (yesClickHandler) yesClickHandler();
	}
	showModalDialog('modalDialog', "", "",
		<div className="confirm-change-message">
			<div className="confirm-change-icon">
				<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FF0000" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
					<circle cx="12" cy="12" r="9" />
					<path d="M12 11v5" />
					<circle cx="12" cy="7.8" r=".7" fill="#FF0000" stroke="none" />
				</svg>
			</div>
			<div className="confirm-change-title">{title}</div>
			<div className="confirm-change-text">{message}</div>
		</div>,
		"confirm-change-popup", false,
		[{ title: confirmBtnTitle, clickHandler: confirmDialog, class: "confirm-change-yes" },
		{ title: i18next.t("cancel"), clickHandler: rejectDialog, class: "confirm-change-no" }],
		rejectDialog)
}
export function unknownErrorMessageDialog(onCloseHandler) {
	let closeDialog = () => {
		hideModalDialog("loadingDialog");
		if (onCloseHandler) onCloseHandler();
	}
	showModalDialog("loadingDialog", i18next.t("error"), "", <div className="info-message">{i18next.t("unknownErrorMessage")}</div>, "feedPopup single-btn", true, [{ title: i18next.t("ok"), clickHandler: closeDialog, class: "btn-primary" }], closeDialog)
}
export function messageDialog(title, message, handleCloseDialog) {
	let closeDialog = () => {
		hideModalDialog('modalDialog')
		if (handleCloseDialog) handleCloseDialog()
	}
	showModalDialog('modalDialog', title, "", <div className="info-message">{message}</div>, "feedPopup single-btn", true, [{ title: i18next.t("ok"), clickHandler: closeDialog, class: "btn-primary" }], closeDialog)
}
export function errorMessageDialog(message, onCloseHandler) {
	messageDialog(i18next.t("error"), message, () => {
		if (onCloseHandler) onCloseHandler();
	});
}
export function viewPdfDialog(nodeRef) {
	let view = function(path) {
		fetch(path, { method: 'POST' })
			.then(async (response) => {
				if (response.ok) {
					let data = await response.json()
					if (data.errorCode) unknownErrorMessageDialog()
					else {
						let path = `/api/file/get?nodeRefs=${nodeRef}`
						if (!data[0].content && !response.url.toLowerCase().includes(path.toLowerCase())) view(path)
						else if (data[0].content) {
							let objectUrl = window.URL.createObjectURL(base64toBlob(data[0].content, "application/pdf"))
							viewFile(objectUrl, data[0].fileName)
						}
						else {
							showModalDialog("loadingDialog", i18next.t("viewingDocument"), "",
								<div className="info-message">{i18next.t("viewedDocumentNotFound")}</div>,
								"feedPopup", true,
								[{ title: i18next.t("ok"), clickHandler: () => hideModalDialog('loadingDialog'), class: "btn-primary" }]);
						}
					}
				}
			})
	}
	view(`/api/file/get?nodeRefs=${nodeRef}`)
}
export async function viewFolderSystemFile(urlPath, fileName) {
	const response = await fetch(urlPath);
	if (response.ok) {
		response.blob().then(blobby => {
			var file = new Blob([blobby], { type: 'application/pdf' });
			var objectUrl = window.URL.createObjectURL(file);
			viewFile(objectUrl, fileName);
		});
	}
	else
		messageDialog(i18next.t("error"), response.status === 404 ? i18next.t("documentNotFound") : i18next.t("unknownErrorMessage"));
}
export function viewFile(objectUrl, fileName, reinvokeAfterView = true) {
	showModalDialog("loadingDialog", i18next.t("viewingDocument"), "", [
		<div className="filter-block-header">
			<ul className="filter-header-buttons one-icons">
				<li>
					<button type="button" className="btn no-bg-btn" onClick={() => {
						let anchor = document.createElement("a")
						anchor.href = objectUrl
						anchor.download = fileName
						anchor.click()
					}}>
						<div>
							<Svg src="/img/icn-download.svg" />
						</div>
						<span>{i18next.t("download")}</span>
					</button>
				</li>
			</ul>
		</div>,
		<PdfViewer src={objectUrl} />
	]
		, "feedPopup max-size with-header-btns", true, [], () => {
			if (reinvokeAfterView) {
				window.URL.revokeObjectURL(objectUrl);
			}
		})
}
export function viewImage(imageUrl) {
	showModalDialog("loadingDialog", "", "", <img src={imageUrl} className="loading-icone" alt="" />, "transparente image-dialog", true);
}
export function isAllowedFileTypeDialog(file, allowedExtensions) {
	let fileName = file?.name;
	if (!allowedExtensions.map(item => mime.lookup(item)).includes(mime.lookup(fileName))) {
		let errorMessage = i18next.t("invalidFileFormatMessage", { extensions: allowedExtensions.join(', ') });
		errorMessageDialog(errorMessage);
		return false;
	}
	return true;
}